import React, {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {styled} from '@material-ui/core'
import {editApplicationBegin, resetEditState} from 'lms/store/actions'
import Form from './Form'
import {getEditApplicationState} from '../../store/selectors'
import {actionTypes} from 'lms/store/constants'
import {useLocation} from 'react-router-dom'

const Content = styled('div')(({theme}) => ({
  marginTop: 20,
  marginBottom: 20,
  padding: 20,
  backgroundColor: theme.palette.background.paper,
}))

const Edit = ({match}) => {
  // Fallback mechanism for when match props aren't properly passed
  const location = useLocation()
  // Extract ID from either match.params or from the URL path
  const pathParts = location.pathname.split('/')
  const pathId = pathParts[pathParts.length - 2] === 'edit' 
    ? pathParts[pathParts.length - 3] // For /systems/:id/edit
    : pathParts[pathParts.length - 1] // For /systems/new
    
  const id = match?.params?.id || (pathParts.includes('new') ? 'new' : pathId)
  const dispatch = useDispatch()
  const editState = useSelector(getEditApplicationState)
  const appInStore = useSelector(state => state.lms?.applications?.data?.byId?.[id] || null)
  const isNewApplication = id === 'new' || location.pathname.includes('/new')

  // For new applications, initialize the edit state immediately on mount
  useEffect(() => {
    // Always reset edit state first before initializing
    dispatch(resetEditState())
    
    if (isNewApplication) {
      dispatch(editApplicationBegin('new'))
    }
  }, [isNewApplication, dispatch])

  // For existing applications, fetch details if not in store
  useEffect(() => {
    if (!isNewApplication && !appInStore && id) {
      dispatch({type: actionTypes.FETCH_APPLICATION_DETAIL_REQUESTED, payload: id})
    }
  }, [id, appInStore, dispatch, isNewApplication])

  // Initialize edit state after data is loaded (for existing) or immediately (for new)
  useEffect(() => {
    try {
      if (isNewApplication) {
        // Already dispatched in the first useEffect
      } else if (appInStore && (!editState || !editState.data || editState.data.id !== id)) {
        // Always reset edit state before initializing for existing applications
        dispatch(resetEditState())
        dispatch(editApplicationBegin(id))
      }
    } catch (error) {
      console.error('Error initializing edit state:', error)
    }
  }, [id, appInStore, editState, dispatch, isNewApplication])

  // Show loading for existing applications that aren't loaded yet
  if (!isNewApplication && !appInStore) {
    return <div>Loading...</div>
  }
  
  // For new applications, only render if edit state is initialized
  if (isNewApplication && (!editState || !editState.data)) {
    return <div>Initializing...</div>
  }
  
  // If we get here, we have the data we need to render the form
  return (
    <Content>
      <Form />
    </Content>
  )
}

export default Edit
